import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-subscribe-ok',
  templateUrl: './subscribe-ok.component.html',
  styleUrls: ['./subscribe-ok.component.css']
})
export class SubscribeOkComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
